export default __webpack_public_path__ + "static/media/ls.04f822b0.svg";